"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledError = exports.StyledText = exports.StyledSpan = exports.StyledInput = exports.StyledLabel = exports.StyledCheckboxContainer = void 0;
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledCheckboxContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
`;
exports.StyledLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  height: 100%;

  ${({ disabled }) => !disabled &&
    (0, styled_components_1.css) `
      cursor: pointer;

      &:hover svg {
        ${({ theme }) => {
        const hoverColor = theme.colors.colours.overlay['digital-black'][50].value;
        return (0, styled_components_1.css) `
            fill: ${hoverColor};
            color: ${hoverColor};
          `;
    }};
      }
    `}

  ${({ required }) => required &&
    (0, styled_components_1.css) `
      &::after {
        content: '*';
        color: ${({ theme }) => theme.colors.colours.system.fail.value};
        margin-left: ${({ theme }) => theme.sizes['3xs'].value};
      }
    `}
`;
exports.StyledInput = styled_components_1.default.input `
  display: none;
`;
exports.StyledSpan = styled_components_1.default.span `
  height: ${({ theme }) => theme.sizes.m.value};
`;
exports.StyledText = (0, styled_components_1.default)(malty_atoms_text_1.Text) `
  margin-left: ${({ theme }) => theme.sizes['2xs'].value};
`;
exports.StyledError = (0, styled_components_1.default)(malty_atoms_text_1.Text) `
  margin-left: ${({ theme }) => theme.sizes['4xs'].value};
`;
//# sourceMappingURL=Checkbox.styled.js.map